import { PageHeader } from '../components/sections/PageHeader';
import { ContactCTA } from '../components/sections/ContactCTA';
import { MISSION, SNAPSHOT, TEAM, TRAINING, TRAINING_PATH, VISION } from '../data/siteData';
import { Reveal } from '../hooks/useMotion';

export const AboutPage = () => (
  <div data-testid="about-page">
    <PageHeader eyebrow="About BuildiTech" title="Driven by purpose, guided by vision">
      A BIM engineering consultancy helping AEC teams deliver better-coordinated, data-driven construction
      projects.
    </PageHeader>

    <section className="sec white">
      <div className="wrap">
        <Reveal className="hd">
          <div className="mono">Company snapshot</div>
          <h2>BIM · Coordination · Digital Delivery · Training</h2>
        </Reveal>
        <div className="cards4">
          {SNAPSHOT.map((s, i) => (
            <Reveal key={s.title} className="card" delay={i * 80}>
              <h3>{s.title}</h3>
              <p>{s.text}</p>
            </Reveal>
          ))}
        </div>
        <div className="mv">
          <Reveal className="m"><h3>Mission</h3><p>{MISSION}</p></Reveal>
          <Reveal className="v" delay={80}><h3>Vision</h3><p>{VISION}</p></Reveal>
        </div>
      </div>
    </section>

    <section className="sec" id="team">
      <div className="wrap">
        <Reveal className="hd">
          <div className="mono">Our team &amp; expertise</div>
          <h2>Technical BIM leadership</h2>
        </Reveal>
        <div className="team">
          {TEAM.map((m) => (
            <figure key={m.name}>
              <figcaption><b>{m.name}</b><span>{m.role}</span></figcaption>
            </figure>
          ))}
          <blockquote>
            Practical experience across modeling, coordination, documentation and digital project workflows.
            <small>Leadership remains accountable for quality, communication and delivery control.</small>
          </blockquote>
        </div>
      </div>
    </section>

    <section className="sec white" id="training">
      <div className="wrap train">
        <div>
          <Reveal className="hd">
            <div className="mono">Skill development program</div>
            <h2>From basics to project-ready BIM professional</h2>
            <p>We train engineers to become project-ready BIM professionals with practical, delivery-focused skills.</p>
          </Reveal>
          <ol>
            {TRAINING.map((t, i) => (
              <li key={t.title}>
                <i>{String(i + 1).padStart(2, '0')}</i>
                <div><b>{t.title}</b><span>{t.text}</span></div>
              </li>
            ))}
          </ol>
          <div className="path">
            {TRAINING_PATH.map((p, i) => (
              <span key={p} style={{ display: 'contents' }}>
                {i > 0 && <i>→</i>}
                <span>{p}</span>
              </span>
            ))}
          </div>
        </div>
        <Reveal className="visual">
          <img src="/images/c2.jpg" alt="Coordinated underground services model" />
          <div className="note">Trainees finish with project simulation on real coordination scenarios.</div>
        </Reveal>
      </div>
    </section>

    <ContactCTA />
  </div>
);

export default AboutPage;
